










import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

import Rap from './index.page.vue';

import {PRINT_GET_PARAMS} from '@/store/modules/print/types';
import {DISABLE_LOADING, ENABLE_LOADING, GET_LOADING} from '@/store/types';

@Component({
  components: {
    Rap
  }
})
export default class extends Vue {
  @Getter(GET_LOADING) isLoading: boolean;
  @Getter(PRINT_GET_PARAMS) params: any;

  @Action(ENABLE_LOADING) enableLoading: Function;
  @Action(DISABLE_LOADING) disableLoading: Function;

  public get dataQuery() {
    return {
      ...this.params.filters,
      name: this.params.reportName
    };
  }

  public created() {
    this.enableLoading();
    setTimeout(() => {
      this.disableLoading();
    }, 10000);
  }

  public mounted() {
    $('<style>@page { size: portrait; }</style>').appendTo(document.head);
  }
}
